import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { KnowledgeTypography } from "@limitless/portal";
import LayoutContainer from "../layout-container/LayoutContainer";
import HeaderIconButton from "../../buttons/header-icon-button/HeaderIconButton";
const useStyles = makeStyles(theme => ({
  actionsContainer: {
    display: "flex",
    flex: 1
  },
  fieldSummaryContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    marginBottom: 16
  },
  fieldTitle: {
    display: "flex",
    flex: 1,
    backgroundColor: "#f8f9fa",
    border: theme.palette.border,
    padding: 5,
    justifyContent: "center"
  },
  summaryTitle: {
    fontWeight: 800
  }
}));
const PropertyContainer = ({
  children,
  title,
  childContainer,
  fields,
  entity,
  actionColumn,
  actionEvent,
  loading,
  gutterBottom
}) => {
  const classes = useStyles();
  const renderHeaderIcon = (field, value, fieldIndex) => {
    return /*#__PURE__*/React.createElement(HeaderIconButton, {
      buttonId: field.id,
      onButtonClick: () => actionEvent(field),
      tooltip: field.tooltip,
      icon: field.icon,
      color: "secondary",
      copyToClipboardFeature: field.copyToClipboard,
      copyValue: field.copyToClipboard ? value : "",
      key: `${fieldIndex}_action`,
      buttonStyle: {
        padding: 8
      }
    });
  };
  const renderTypographyComponent = (key, value) => {
    return /*#__PURE__*/React.createElement(Typography, {
      key: key,
      component: "span"
    }, value !== null && value !== void 0 ? value : "");
  };
  const renderActionColumn = (field, fieldIndex, value, componentList) => {
    if (actionColumn) {
      const showAction = field.icon || field.renderAction;
      if (showAction) {
        if (field.renderAction) {
          componentList.push(/*#__PURE__*/React.cloneElement(field.renderAction(entity), {
            key: `${fieldIndex}_prop-summary`
          }));
        } else {
          componentList.push(renderHeaderIcon(field, value, fieldIndex));
        }
      } else {
        componentList.push(renderTypographyComponent(`${fieldIndex}"_action"`, ""));
      }
    }
  };
  const components = React.useMemo(() => {
    const component = [];
    if (fields) {
      if (loading) {
        fields.map((field, fieldIndex) => {
          component.push(renderTypographyComponent(`${fieldIndex}"_field"`, field.name));
          component.push(/*#__PURE__*/React.createElement("div", {
            key: `empty${fieldIndex}`
          }));
        });
      } else {
        fields.map((field, fieldIndex) => {
          if (field.component) {
            component.push(renderTypographyComponent(`${fieldIndex}"_field"`, field.name));
            component.push(/*#__PURE__*/React.cloneElement(field.component(entity), {
              key: `${fieldIndex}_component`
            }));
            renderActionColumn(field, fieldIndex, null, component);
          } else if (field.renderPropSummary) {
            const value = field.fieldKey ? entity[field.fieldKey] : field.fieldExtractor(entity);
            component.push(renderTypographyComponent(`${fieldIndex}"_field"`, field.name));
            component.push(/*#__PURE__*/React.cloneElement(field.renderPropSummary(value, entity), {
              key: `${fieldIndex}_prop-component`
            }));
            renderActionColumn(field, fieldIndex, value, component);
          } else {
            const value = field.fieldKey ? entity[field.fieldKey] : field.fieldExtractor(entity);
            component.push(renderTypographyComponent(`${fieldIndex}"_field"`, field.name));
            component.push(renderTypographyComponent(`${fieldIndex}"_value"`, value));
            renderActionColumn(field, fieldIndex, value, component);
          }
        });
      }
    }
    return component;
  }, [fields, entity]);
  const getTemplateColumns = () => {
    if (actionColumn) {
      return {
        gridTemplateColumns: "3fr 6fr min-content"
      };
    }
    return {};
  };
  const getColumnStyles = () => {
    const columnStyles = [{
      column: 0,
      styles: {
        margin: "auto 0px",
        padding: "5px 8px 5px 0"
      }
    }];
    if (actionColumn) {
      columnStyles.push({
        column: 1,
        styles: {
          paddingRight: 10
        }
      });
      columnStyles.push({
        column: 2,
        styles: {
          justifySelf: "left"
        }
      });
      columnStyles.push({
        column: 3,
        styles: {
          justifySelf: "end",
          padding: 0
        }
      });
    }
    return columnStyles;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.messagePropsSummaryContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.fieldSummaryContainer
  }, title && /*#__PURE__*/React.createElement("div", {
    className: classes.fieldTitle,
    style: gutterBottom ? {
      marginBottom: 16
    } : {}
  }, /*#__PURE__*/React.createElement(KnowledgeTypography, {
    align: "center",
    label: title
  })), fields && /*#__PURE__*/React.createElement(LayoutContainer, {
    columns: actionColumn ? 3 : 2,
    fillAvailableSpace: true,
    align: "left",
    gridStyles: {
      justifyItems: "start",
      marginTop: "16px",
      ...getTemplateColumns()
    },
    columnStyles: getColumnStyles()
  }, components), !fields && /*#__PURE__*/React.createElement("div", {
    className: childContainer
  }, children)));
};
export default PropertyContainer;
PropertyContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  title: PropTypes.string,
  childContainer: PropTypes.string,
  fields: PropTypes.array,
  entity: PropTypes.object,
  actionColumn: PropTypes.bool,
  actionEvent: PropTypes.func,
  loading: PropTypes.bool,
  gutterBottom: PropTypes.bool
};
PropertyContainer.defaultProps = {
  fields: null,
  entity: null,
  actionColumn: false,
  loading: false,
  gutterBottom: false
};